import React from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';

import { Typography, SxProps, Theme } from '@mui/material';

const ASK_LUBAV_STRINGS = appStrings.modules.nugget.askLubav;

export type AskLubavErrorCode = 'NOT_LOGGED_IN' | 'RESUME_REQUIRED' | 'BLUEPRINT_REQUIRED';

type AskLubavErrorProps = Readonly<{
  errorCode?: AskLubavErrorCode;
  onBackrsProfileClick?: () => void;
  onBlueprintClick?: () => void;
  onNetworksClick?: () => void;
  onProsperClick?: () => void;
}>;

export const AskLubavError = ({
  errorCode,
  onBackrsProfileClick,
  onBlueprintClick,
  onNetworksClick,
  onProsperClick,
}: AskLubavErrorProps) => {
  return (
    <Typography sx={errorCode ? errorStyle : defaultErrorStyle}>
      {errorCode ? (
        <>
          {ASK_LUBAV_STRINGS.errors[errorCode]}
          {errorCode === 'RESUME_REQUIRED' && (
            <span style={errorLinkStyle} onClick={onBackrsProfileClick}>
              {ASK_LUBAV_STRINGS.backrsProfile}
            </span>
          )}
          {errorCode === 'BLUEPRINT_REQUIRED' && (
            <span style={errorLinkStyle} onClick={onBlueprintClick}>
              {ASK_LUBAV_STRINGS.blueprint}
            </span>
          )}
        </>
      ) : (
        <>
          {ASK_LUBAV_STRINGS.errors.DEFAULT}
          {onNetworksClick && (
            <span style={errorLinkStyle} onClick={onNetworksClick}>
              {ASK_LUBAV_STRINGS.networks}
            </span>
          )}
          {onNetworksClick && onProsperClick && ' or '}
          {onProsperClick && (
            <span style={errorLinkStyle} onClick={onProsperClick}>
              {ASK_LUBAV_STRINGS.prosper}
            </span>
          )}
        </>
      )}
    </Typography>
  );
};

const errorStyle: SxProps<Theme> = {
  color: appColors.color.red2,
  lineHeight: 1.25,
  fontWeight: 'bold',
  fontStyle: 'italic',
  fontSize: '11pt',
};

const defaultErrorStyle: SxProps<Theme> = {
  lineHeight: 1.25,
  fontSize: '11pt',
};

const errorLinkStyle: React.CSSProperties = {
  textDecoration: 'underline',
  cursor: 'pointer',
};
